'use client'

import { type RefObject, useEffect, useState } from 'react'

import { viewportHeight } from '@/features/landing/walk/use-walk'
import { trackProgress } from '@/features/landing/walk/walk'

// Progress (0..1) of a sticky stage over its scroll track. Reduced
// motion is the caller's call (the Method figure shows finished stills).
export function useTrackProgress(ref: RefObject<HTMLElement | null>): number {
    const [p, setP] = useState(0)
    useEffect(() => {
        let raf = 0
        const update = () => {
            raf = 0
            const el = ref.current
            if (!el) return
            const r = el.getBoundingClientRect()
            setP(
                trackProgress(
                    r.top + window.scrollY,
                    r.height,
                    viewportHeight(),
                    window.scrollY
                )
            )
        }
        const onScroll = () => {
            if (!raf) raf = requestAnimationFrame(update)
        }
        update()
        window.addEventListener('scroll', onScroll, { passive: true })
        window.addEventListener('resize', onScroll)
        return () => {
            window.removeEventListener('scroll', onScroll)
            window.removeEventListener('resize', onScroll)
            if (raf) cancelAnimationFrame(raf)
        }
    }, [ref])
    return p
}
